import { render, staticRenderFns } from "./PostEditoCreateFacebook.vue?vue&type=template&id=4fd4433b&scoped=true&"
import script from "./PostEditoCreateFacebook.vue?vue&type=script&lang=js&"
export * from "./PostEditoCreateFacebook.vue?vue&type=script&lang=js&"
import style0 from "./PostEditoCreateFacebook.vue?vue&type=style&index=0&id=4fd4433b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4433b",
  null
  
)

export default component.exports